import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import swal from 'sweetalert2';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from '../services/common.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(public router: Router, public _injector: Injector,
        private environmentService: EnvironmentService,
        private commonService: CommonService) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                event => { },
                (error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this.commonService.announceUnauthorized();
                        swal.fire({
                            title: 'Información',
                            text: 'Debe iniciar sesión para ver este contenido.',
                            icon: 'error',
                            backdrop: '#0c0f0f'
                        }).finally(() => {
                            let curentRoute = this.router.url.substr(12);
                            let parameter = "";
                            if (curentRoute.length > 0) parameter = "?ftrlgn=" + curentRoute;
                            window.location.href = this.environmentService.portalWebUrl + parameter;
                        });

                    } else {
                        swal.fire({
                            title: 'Ocurrió un error durante el proceso, intente nuevamente.',
                            icon: 'error',
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 4000
                        });
                    }
                }
            )
        );
    }
}
